<template>
  <el-row class="menu-tutorals-videos">
    <h5 class="title" v-if="widthDesktop">{{ $t("tutoralsVideos.menu.titleMenu") }}</h5>
    <el-col :span="24">

      <el-menu
          :class="{ 'MainMenu--menuOpened': menuOpened }"
          default-active="1"
          class="tutorals-videos"
          mode="vertical"
      >
        <el-menu-item index="1" @click="themeLocation(1)" class="link-summary">
          <ubi-icon class="icon-theme" name="dashboard"/>
          <span class="link" v-if="widthDesktop"> {{ $t("tutoralsVideos.menu.linkDashboard") }}</span>
        </el-menu-item>
        <el-menu-item index="2" @click="themeLocation(2)" class="link-summary" v-if="isPromoteur">
          <ubi-icon class="icon-theme" name="announcement"/>
          <span class="link" v-if="widthDesktop">{{ $t("tutoralsVideos.menu.linkProgramsPage") }}</span>
        </el-menu-item>
        <el-menu-item index="2" @click="themeLocation(2)" class="link-summary" v-else>
          <ubi-icon class="icon-theme" name="announcement"/>
          <span class="link" v-if="widthDesktop">{{ $t("tutoralsVideos.menu.linkAnnouncementsPage") }}</span>
        </el-menu-item>
        <el-menu-item index="3" @click="themeLocation(3)" class="link-summary">
          <ubi-icon class="icon-theme" name="direction"/>
          <span class="link" v-if="widthDesktop">{{ $t("tutoralsVideos.menu.linkBroadcast") }}</span>
        </el-menu-item>
        <el-menu-item index="4" @click="themeLocation(4)" class="link-summary">
          <ubi-icon class="icon-theme" name="agenda"/>
          <span class="link" v-if="widthDesktop">{{ $t("tutoralsVideos.menu.linkContactManager") }}</span>
        </el-menu-item>
        <el-menu-item index="5" @click="themeLocation(5)" class="link-summary">
          <ubi-icon class="icon-theme" name="world"/>
          <span class="link" v-if="widthDesktop">{{ $t("tutoralsVideos.menu.linkSocialManagement") }}</span>
        </el-menu-item>
      </el-menu>
    </el-col>
  </el-row>
</template>

<script>
import { Menu, MenuItem } from 'element-ui'
import UbiIcon from '@/components/Icon'
import logoUbiflow from '@/assets/login_logo.png'

export default {
  name: 'MenuTutoralsVideos',
  props: ['widthDesktop'],
  components: {
    UbiIcon,
    ElMenu: Menu,
    ElMenuItem: MenuItem
  },
  data () {
    return {
      logoUbiflow: logoUbiflow,
      initialThemeId: '1',
      isActive: false
    }
  },
  computed: {
    isPromoteur () {
      return this.$store.getters.getSitimmoUser.metier === 'PROMOTEUR'
    },
    isVo () {
      return this.$store.getters.getSitimmoUser.univers === 'VO'
    },
    menuOpened () {
      return this.$store.getters.getMenuOpened
    }
  },
  methods: {
    themeLocation (themeIdChoose) {
      this.$router.push({ path: this.$route.path, query: { theme: themeIdChoose } })
    }
  },
  mounted () {
    this.$router.push({ path: this.$route.path, query: { theme: this.initialThemeId } })
  }
}
</script>

<style lang="scss" scoped>
@import "@/theme/_bootstrap.scss";

@include media-breakpoint-up(xl) {
  .menu-tutorals-videos {
    margin-top: 35px;
    padding-top: 20px;
    background-color: $blue-pastel;
    height: 70vh;

    &::before {
      background-color: $body-bg;
      background-image: url("~@/assets/menu-planetes.png");
      @include image-retina("~@/assets/menu-planetes@2x.png", 26px, 17px);
      background-position: center center;
      background-repeat: no-repeat;
      border-radius: 100%;
      border: 1px solid $gray-200;
      content: "";
      height: 40px;
      position: absolute;
      right: 3px;
      top: 0;
      transform: translateY(-50%);
      width: 40px;
      z-index: 1;
    }

    .title {
      font-family: "Dosis", Helvetica, Arial, sans-serif;
      margin-left: 22px;
      font-size: 30px;
      font-weight: $font-weight-bold;
      color: #3f7785;
    }

    .el-menu-item, .link-submenu {
      font-family: "Dosis", Helvetica, Arial, sans-serif;
      margin-left: 5px;

      &:not(.is-active) {
        color: #3f7785 !important;
        background: transparent;

        &:before {
          width: 0;
          content: "";
          position: absolute;
          left: -5px;
          top: 55%;
          border-bottom: 1px solid #3f7785;
          transition: width 0.3s;
        }
      }

      &:hover {
        background: transparent;
      }

      &.is-active {
        color: #00b4cc !important;
        background: transparent;

        &:before {
          width: 18px;
          content: "";
          position: absolute;
          left: -5px;
          top: 55%;
          border-bottom: 1px solid #3f7785;
          transition: width 0.3s;
        }
      }
      .link {
        line-height: -2;
        font-size: 16px;

        &:hover {
          color: #00b4cc;
        }
      }
    }

    .item-group {
      font-size: 16px;
    }

    .icon-theme {
      font-size: 20px;
      margin-left: 10px;
      margin-right: 10px;
    }

    .logo-ubiflow {
      position: absolute;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);

      img {
        width: 150px;
      }
    }
  }

  .submenu-is-active {
    color: #00b4cc;
  }

  .submenu-is-display-none{
    display: none;
  }
}

@include media-breakpoint-down(lg) {
  .menu-tutorals-videos {
    .icon-theme {
      font-size: 20px;
      margin-left: -5px;
    }
  }
}

.counter-video {
  margin-left: 6px;
}
</style>
